export interface BlogPost {
  slug: string;
  key: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
}

export const blogPosts: BlogPost[] = [
  {
    slug: '/blog/fines-for-no-vignette',
    key: 'post1',
    title: 'What happens if you drive without a valid vignette',
    excerpt: 'Fines range from 120 € to 800 € depending on country. Here is what enforcement looks like in 2026.',
    category: 'Legal',
    readTime: '5 min',
  },
  {
    slug: '/blog/paying-tolls-with-trailer',
    key: 'post2',
    title: 'Driving with a trailer: when do you need a separate vignette?',
    excerpt: 'Trailer rules differ dramatically by country. Sometimes the trailer needs nothing, sometimes it needs its own vignette.',
    category: 'Planning',
    readTime: '4 min',
  },
  {
    slug: '/blog/what-is-an-e-vignette',
    key: 'post3',
    title: 'E-vignette vs sticker: what changed in the last 5 years',
    excerpt: 'Physical stickers are disappearing. Here is what the digital e-vignette is, how it is enforced, and why it is harder to fake.',
    category: 'Basics',
    readTime: '4 min',
  },
  {
    slug: '/blog/multi-country-vignette-guide',
    key: 'post4',
    title: 'Road trip through 5 countries: which vignettes do you actually need',
    excerpt: 'Planning a Central European tour? Here is exactly which countries require a vignette, which use toll booths, and where motorways are free.',
    category: 'Planning',
    readTime: '7 min',
  },
  {
    slug: '/blog/motorcycle-vignette-rules',
    key: 'post5',
    title: 'Motorcycle vignettes: different rules, lower prices',
    excerpt: 'Motorcycles often pay less, but the rules are not always the same. Some countries tie the vignette to the rider, not the plate.',
    category: 'Basics',
    readTime: '3 min',
  },
  {
    slug: '/blog/vignette-enforcement-cameras',
    key: 'post6',
    title: 'How ANPR cameras catch drivers without a vignette',
    excerpt: 'Automatic number plate recognition systems scan every plate on the motorway. Here is how they work and where they are installed.',
    category: 'Technology',
    readTime: '5 min',
  },
  {
    slug: '/blog/vignette-prices-2026',
    key: 'post7',
    title: 'Vignette prices in 2026: complete comparison across 8 countries',
    excerpt: 'From Austria\'s €96.40 annual to Romania\'s €3 one-week pass, see the full price breakdown and find the best value for your trip.',
    category: 'Comparison',
    readTime: '6 min',
  },
  {
    slug: '/blog/avoid-vignette-scams',
    key: 'post8',
    title: 'Fake vignette websites: how to spot and avoid scams',
    excerpt: 'Scammers clone official toll sites and sell invalid digital vignettes. Learn the red flags and always verify before you pay.',
    category: 'Safety',
    readTime: '4 min',
  },
  {
    slug: '/blog/vignette-start-date-strategy',
    key: 'post9',
    title: 'Choosing the right validity start date saves you money',
    excerpt: 'Most digital vignettes let you pick a future start date up to 30 days ahead. Here is how to time your purchase for maximum coverage.',
    category: 'Tips',
    readTime: '3 min',
  },
];
